var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-application" }, [
    _c("div", { staticClass: "grey lighten-5" }, [
      _c(
        "div",
        { staticClass: "d-flex", attrs: { "no-gutters": "" } },
        [
          _c("v-col", [
            _c(
              "div",
              { staticClass: "d-flex justify-space-between" },
              [
                _c("v-text-field", {
                  attrs: { solo: "" },
                  model: {
                    value: _vm.stockName,
                    callback: function ($$v) {
                      _vm.stockName = $$v
                    },
                    expression: "stockName",
                  },
                }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "m-2",
                    attrs: { outlined: "", color: "teal" },
                    on: { click: _vm.onSearch },
                  },
                  [_vm._v("検索")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("v-col"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mb-6 stock-selection d-flex",
          attrs: { "no-gutters": "" },
        },
        [
          _c("v-col", { staticClass: "stock-list" }, [
            _c(
              "div",
              { staticClass: "m-4" },
              [
                _vm._v("\n          ストック一選択\n          "),
                _vm._l(_vm.showingExams, function (exam) {
                  return _c(
                    "div",
                    {
                      key: exam.id,
                      staticClass: "d-flex justify-space-between align-center",
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(exam.name) + "\n            "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "m-2",
                          attrs: { outlined: "", color: "teal", dark: "" },
                          on: {
                            click: function ($event) {
                              return _vm.select(exam)
                            },
                          },
                        },
                        [_vm._v("選択")]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("v-col", { staticClass: "stock-list" }, [
            _c(
              "div",
              { staticClass: "m-4" },
              [
                _vm._v(
                  "\n          ストックから質問数設定: " +
                    _vm._s(_vm.totalQuestionCount) +
                    "\n          "
                ),
                _vm._l(_vm.forms, function (form) {
                  return _c(
                    "div",
                    { key: form.exam.id, staticClass: "stock-exam p-3 mb-3" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(form.exam.name) +
                          "\n            "
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-space-between mt-3" },
                        [
                          _c("v-text-field", {
                            attrs: { solo: "", type: "number" },
                            model: {
                              value: form.questionCount,
                              callback: function ($$v) {
                                _vm.$set(form, "questionCount", $$v)
                              },
                              expression: "form.questionCount",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "m-2",
                              attrs: { outlined: "", color: "teal", dark: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.remove(form.exam)
                                },
                              },
                            },
                            [_vm._v("削除")]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-center",
          attrs: { "no-gutters": "" },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "success", dark: "" },
              on: { click: _vm.onSubmit },
            },
            [_vm._v("テスト作成")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }